import { ReactNode } from 'react';
import { Flex } from 'reflexbox';
import styled from 'styled-components';

import Column from 'packages/kakapo-ui-kit/components/grid/Column';
import { toRgbString } from 'packages/kakapo-ui-kit/helpers/HexColor';
import { OptionalInvisibleButton } from 'packages/kakapo-ui-kit/components/buttons/InvisibleButton';

interface IComposableListItemProps {
	onClick?: () => void;
	children: ReactNode;
	accessory?: ReactNode;
	controls?: ReactNode;
	compact?: boolean;
}

interface IComposableListItemControlsProps {
	spaced?: boolean;
}

const ComposableListItemElement = styled.div`
	width: 100%;
	background-color: ${(props) => props.theme.colors.white};
	border: 1px solid ${(props) => props.theme.colors.lightBlue};
	margin-bottom: 10px;
	border-radius: 6px;

	p {
		margin-bottom: 0;
		text-align: left;
	}
`;

export const ComposableListItem = ({
	onClick,
	children,
	accessory,
	controls,
	compact,
}: IComposableListItemProps) => (
	<ComposableListItemElement>
		<OptionalInvisibleButton onClick={onClick}>
			<Column px={compact ? 2 : 3} py={2}>
				<Flex flexDirection="row" justifyContent="space-between" alignItems="center">
					<Column>{accessory}</Column>
					<Column px={compact ? 2 : 3} flex={1}>
						{children}
					</Column>
					<Column>{controls}</Column>
				</Flex>
			</Column>
		</OptionalInvisibleButton>
	</ComposableListItemElement>
);

export const ComposableListItemControls = styled.div<IComposableListItemControlsProps>`
	margin-right: -5px;
	${(props) =>
		props.spaced
			? `
		margin-top: -5px;
	`
			: ''}
`;

export const ComposableListItemControlsButton = styled.button`
	width: 30px;
	height: 30px;
	border-radius: 15px;
	background-color: transparent;
	display: flex;
	justify-content: center;
	align-items: center;
	border: 0;

	svg {
		width: 12px;
	}

	&:active {
		background-color: rgba(${(props) => toRgbString(props.theme.colors.primary)}, 0.1);
	}
`;
